import * as types from '../actions/types';
const INITIAL = {
  data: null,
  isError: false
};

const userCertificationReducer = (state = INITIAL, action) => {
  switch (action.type) {
    case types.USER_CERTIFICATION_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.USER_CERTIFICATION_SUCCEEDED:
      return {
        ...state,
        data: action.data.data,
        error: null
      };
    case types.USER_CERTIFICATION_FAILED:
      return {
        ...state,
        data: null,
        isError: true,
        error: action.error
      };
    case types.UPDATE_USER_CERTIFICATION_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.UPDATE_USER_CERTIFICATION_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };
    default:
      return state;
  }
};

export default userCertificationReducer;
